import { ComponentProps } from 'react';
import {
  FlexColumn,
} from '@equifinance/shared';
import styled from 'styled-components';
import Page from '../../Page';
import CompanyTabNav from './CompanyTabNav';

const Container = styled(FlexColumn)`
  width:100%;
`;

export enum CompanyPageType {
  BROKER_DETAILS = 'BROKER_DETAILS',
  AGREEMENT = 'AGREEMENT',
  MANAGE_USER = 'MANAGE_USER',
  MANAGE_YOUR_DETAILS = 'MANAGE_YOUR_DETAILS'
}

type CompanyTabPageProps = ComponentProps<typeof Page> & { page: CompanyPageType };

export default function CompanyTabPage(props: CompanyTabPageProps) {
  const { children, page, ...pageProps } = props;

  return (
    <Page {...pageProps}>
      <Container>
        <CompanyTabNav page={page} />
        {children}
      </Container>
    </Page>
  );
}
